import React, { useState, useEffect } from 'react';
import moment from "moment";
// import { useForm } from 'react-hook-form'
import Menubar from '../components/Menubar';
import { useDispatch, useSelector } from 'react-redux'
import { findUser, updateUser } from '../store/actions/userAction'
import UploadImage from "../components/uploadImage";

import { TextField, Container, Typography, Grid, Card, CardContent, Button, MenuItem, Select } from '@material-ui/core';
import { Accordion, AccordionSummary, AccordionDetails, Divider } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InputBase from '@material-ui/core/InputBase';

import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  containerOtpLogin : {
    paddingTop: "7%",
    paddingLeft: "22%",
    backgroundColor: "#e8e8e8",
    paddingRight: "7%",
    paddingBottom: "14%",

    [theme.breakpoints.down("sm")]: {
      paddingTop: "30%",
      paddingLeft: "5%",
      paddingRight: "5%"
    },
  },
  contentOtpLogin: {
    background: '#fff',
    padding: '2rem 2.4rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  gridAccordionOtpLogin: {
    background: '#fff',
    padding: '2rem 2.5rem',
    marginTop: '1rem',
    borderRadius: "5px",
    boxShadow: "0px 5px 5px 0px #00000033"
  },
  accordionHeading: {
    fontSize: "18px",
    fontWeight: "500",
  },
  subGridContainer: {
    display: "flex",
    flexDirection: "row",
    width: "80%"
  }
}));


const Profile = () => {
  const classes = useStyles();
  const dispatch = useDispatch()
  const history = useHistory()
  const [ input, setInput ] = useState({
    name: '',
    email: '',
    phone: '',
    companyName: '',
    companyBusinessSection: '',
    companyAddress: '',
    profileImageUrl: '',
    image: ''
  })
  const [business, setBusiness] = useState('')


  const businessCategory = [
    'Teknologi informasi',
    'Lainnya'
  ];

  const handleChangeBusiness = (event) => {
    setBusiness(event.target.value);
  };

  // const [ creditCard, setCreditCard ] = useState({
  //   name: '',
  //   number: '',
  //   valid: '',
  //   cvc: '',
  // })

  useEffect(() => {
    dispatch(findUser())
  }, [])

  const user = useSelector(state => state.userReducer.userLogin)

  useEffect(() => {
    if (user) {
      const newInput = {
          name: user.name,
          email: user.email? user.email : '',
          phone: user.phone? user.phone : '',
          companyName: user.companyName? user.companyName : '',
          companyAddress: user.companyAddress? user.companyAddress : '',    
          profileImageUrl: user.profileImageUrl? user.profileImageUrl : ''    
      }
      setInput(JSON.parse(JSON.stringify(newInput)))
      // setBusiness(user.companyBusinessSection);
      }
  }, [user])

  const handleImageData = (imageFile) => {
    setInput({ ...input, image: imageFile })
  }

  const handleFormChange = (e) => {
    let { name, value } = e.target
    setInput({ ...input, [name]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const { name, email, phone, companyName, companyAddress, image } = input
    const formData = new FormData()
    if (image) {
      formData.append('image', image)      
    }
    formData.append('name', name)
    formData.append('email', email)
    formData.append('phone', phone)
    formData.append('companyName', companyName)
    formData.append('companyAddress', companyAddress)
    formData.append('companyBusinessSection', business)
    dispatch(updateUser(formData))
    history.push('/app')
  }

  const uploadComponentData = {
    page: "profile",
    photoUrl: user.profileImageUrl
  }

  const stripeCardNumberValidation = (cardNumber) => {
    const regexPattern = {
      MASTERCARD: /^5[1-5][0-9]{1,}|^2[2-7][0-9]{1,}$/,
      VISA: /^4[0-9]{2,}$/,
    };
    
    for (const card in regexPattern) {
      if (cardNumber.replace(/[^\d]/g, "").match(regexPattern[card])) {
        if (cardNumber) {
          return cardNumber && /^[1-6]{1}[0-9]{14,15}$/i.test(cardNumber.replace(/[^\d]/g, "").trim())? "" : "Enter a valid Card";
        }
      }
    }
    return "Enter a valid Card";
  }

  const stripeCardExpirValidation = (value) => {
    if (value) {
      if (/^(0[1-9]|1[0-2])\/[0-9]{2}$/i.test(value.trim())) {
        let today = new Date();
        let CurrentDate = moment(new Date(today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate()));
        let visaValue = value.split("/");
        let visaDate = new Date(`20${visaValue[1]}`, visaValue[0], 0);
  
        return CurrentDate < moment(visaDate) ? undefined : "Please enter valid date";
      } else {
        return "Invalid date format";
      }
    }
  };

  const textWithSpacesOnly = (value) => {
    if (value) {
      if (/^[a-zA-Z ]*$/i.test(value)) {
        return undefined;
      } else {
        return "Only alphabets";
      }
    } else {
      return undefined;
    }
  };
  
  const minLength = (min) => (value) => value && value.length < min ? `Must be 3 characters or more` : undefined;

  const BootstrapInput = withStyles((theme) => ({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: 'transparent',
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: '#80bdff',
        boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
      },
    },
  }))(InputBase);
  

  return (
  <React.Fragment>
  <Menubar/>
  <Grid item xs={12} md={12} className={classes.containerOtpLogin}>
    <Typography component="h1" variant="h5" align="center" color="textPrimary" spacing={4} gutterBottom>
        Profile
    </Typography>
    <br/>
    <Grid container>
      <Grid item xs={12} md={12} className={classes.contentOtpLogin}>
      <div>
        <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className="mb-15">
            <Grid item>
                <Typography className="d-flex reguler" style={{flexDirection: "row", justifyContent: "left"}}>
                  General
                </Typography>        
            </Grid>
            <Grid item xs={12} style={{marginBottom: "1.5rem"}}>
              <UploadImage imageData={handleImageData} uploadComponentData={uploadComponentData}/>
            </Grid>
        </Grid>
            <div>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={4}>
                      <Grid item xs={12} md={6}>
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Nama</p>
                        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        placeholder="Masukkan Nama Anda"
                        id="name"
                        name="name"
                        value={input.name}
                        // autoFocus
                        onChange={handleFormChange}
                        style={{marginBottom: "1.5rem"}}
                        />
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Email</p>
                        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        placeholder="Masukkan Email Anda"
                        id="email"
                        name="email"
                        value={input.email}
                        // autoFocus
                        onChange={handleFormChange}
                        style={{marginBottom: "1.5rem"}}
                        />
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Nomor Handphone</p>
                        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        placeholder="Masukkan Nomor Handphone"
                        id="phone"
                        name="phone"
                        value={input.phone}
                        // autoFocus
                        onChange={handleFormChange}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}> 
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Nama Kantor</p>
                        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        placeholder="Masukkan Nama Kantor"
                        name="companyName"
                        id="companyName"
                        value={input.companyName}
                        // autoFocus
                        onChange={handleFormChange}
                        style={{marginBottom: "1.5rem"}}
                        />
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Bidang Usaha</p>
                        <Select
                          fullWidth
                          displayEmpty
                          required
                          value={business}
                          onChange={handleChangeBusiness}
                          input={<BootstrapInput />}
                          inputProps={{ 'aria-label': 'Without label' }}
                          style={{margin: '8px 0 4px 0', marginBottom: "1.5rem"}}
                        >
                          <MenuItem disabled value="">
                            <em className={classes.placeholderSelect}>Pilih Bidang Usaha</em>
                          </MenuItem>
                          {businessCategory.map((businessOption) => (
                            <MenuItem key={businessOption} value={businessOption}>
                              {businessOption}
                            </MenuItem>
                          ))}
                        </Select>

                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Alamat Kantor</p>
                        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        placeholder="Masukkan Alamat Kantor"
                        id="companyAddress"
                        name="companyAddress"
                        value={input.companyAddress}
                        // autoFocus
                        onChange={handleFormChange}
                        />
                      </Grid>
                    </Grid>
                    
                    <div className="d-flex mt-15" style={{justifyContent: "flex-end"}}>
                      <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => console.log('test edit button')}
                      className="btn-white text-transform-unset"
                      style={{padding: "5px 40px", marginRight: "20px"}}
                      >
                      Edit
                      </Button>

                      <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className="btn-black text-transform-unset"
                      style={{padding: "5px 40px"}}
                      onClick={handleSubmit}
                      >
                      Simpan
                      </Button>
                    </div>
            </form>
            </div>        
        </div>
      </Grid>
    </Grid>
    <br/>
    <Grid item xs={12} md={12} className={classes.contentOtpLogin}>
    <div>
        <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className="mb-15">
            <Grid item>
                <Typography className="d-flex reguler" style={{flexDirection: "row", justifyContent: "left"}}>
                  Informasi Tagihan
                </Typography>        
            </Grid>
        </Grid>
            <div>
                <form onSubmit={() => console.log('in construction')}>
                    <Grid container spacing={4}>
                      <Grid item xs={12} md={6}>
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Nama Pada Kartu Kredit</p>
                        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        placeholder="Masukkan Nama Pada Kartu"
                        id="senderID"
                        name="senderID"
                        style={{marginBottom: "1.5rem"}}
                        />
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Nomor Kartu Kredit</p>
                        <TextField
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        placeholder="Masukkan Nomor Pada Kartu"
                        id="brand"
                        name="brand"
                        />
                      </Grid>
                      <Grid item xs={12} md={6}> 
                        <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Masa Berlaku</p>
                        <div className={classes.subGridContainer} style={{justifyContent: "flex-start"}}>
                          <div>
                            <TextField
                            variant="outlined"
                            margin="dense"
                            placeholder="BB / TH"
                            style={{marginBottom: "2.5rem", width: "100%",padding: "0px 15px 5px 0px", marginRight: "5px"}}
                            />
                          </div>
                          <div>
                          <TextField
                            variant="outlined"
                            margin="dense"
                            placeholder="CVC"
                            style={{marginBottom: "2.5rem", padding: "0px 10px 5px 0px", marginRight: "5px"}}
                            />                            
                          </div>
                          <div className="d-flex" style={{marginTop:"0.75rem"}}>
                            <img alt="mastercard logo" src="/icon-mastercard.png" style={{height: "40px", width: "50px", marginRight: "3px"}}/>
                            <img alt="visa logo" src="/icon-visa.png" style={{height: "40px", width: "40px"}}/>
                          </div>    
                        </div>
                        
                        <div className="d-flex mt-15" style={{justifyContent: "flex-end"}}>
                          <Button
                          variant="contained"
                          color="secondary"
                          className="btn-white text-transform-unset"
                          style={{padding: "5px 40px", marginRight: "20px"}}
                          >
                          Edit
                          </Button>

                          <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          className="btn-black text-transform-unset"
                          style={{padding: "5px 40px"}}
                          >
                          Simpan
                          </Button>
                        </div>
                      </Grid>
                    </Grid>                    
            </form>
            </div>
            
    </div>
    </Grid>
    <Grid item xs={12} md={12} className={classes.gridAccordionOtpLogin}>
      <Typography component="h1" variant="h6" align="left" color="textPrimary" spacing={4} gutterBottom>
          Lembar Tagihan
      </Typography>
      <br/>
      <p className="font-size-16 reguler text-darkgrey" style={{marginBottom: "-5px"}}>Anda Belum Memiliki Tagihan</p>
    </Grid>
  </Grid>
  <Divider/>
  </React.Fragment>
  );
}

export default Profile;
